import React from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Row,
  Button,
  Badge,
} from 'reactstrap';

import {
  Field,
} from 'redux-form';

import TextBox from '../../../../shared/components/form/TextBox';
import renderSelectField from '../../../../shared/components/form/Select';

const CronogramaClasesTable = ({
  materiaPeriodo,
  fields = {},
  meta: { error, submitFailed },
  onDeleteItemArray,
  onChangeText,
  onChangeSelect,
  items,
  profesores,
}) => {
  const isNew = items.some(o => !o.deleted && o.id === 0);
  // console.log(this);
  return (
    <div className="form__form-group-field" style={{ flexDirection: 'column' }}>
      <div>
        <div style={{ display: 'flex', gap: '1rem', flexDirection: 'column' }}>
          {fields.map((objetivo, index) => {
            // console.log({ item: items[index], index });
            if (!items[index]) {
              return null;
            }

            return (
              <div
                key={`${objetivo}`}
                id={`${objetivo}`}
                style={{ borderRadius: '10px', padding: '0' }}
                className={(items[index].deleted || (items[index].id > 0 && isNew)) ? 'hidden' : ''}
              >
                <div style={{ borderTop: '0' }}>
                  <Row
                    className="wizard__subform"
                    style={{
                      borderRadius: '10px', borderTop: '0', marginRight: '0', marginLeft: '0',
                    }}
                  >
                    <Col md={12}>
                      <div style={{
                        display: 'flex',
                        gap: '1rem',
                        justifyItems: 'center',
                        justifyContent: 'flex-start',
                        alignItems: 'baseline',
                        padding: '0.4rem',
                      }}
                      >
                        <h3><Badge color="primary">#{index + 1}</Badge></h3>
                        {
                          materiaPeriodo.canEditarPlaneamiento ? (
                            <Button
                              key={`btn-remove-${objetivo}`}
                              onClick={() => onDeleteItemArray({ name: fields.name, index })}
                              size="sm"
                              outline
                              color="danger"
                              style={{ marginBottom: '0px' }}
                              className="font-weight-bold"
                              title={`Eliminar cronograma #${index + 1}`}
                            >
                              <i className="fa fa-trash" aria-hidden="true" />
                            </Button>
                          ) : null
                        }
                      </div>
                    </Col>

                    <div className="col-md-3 col-sm-12">
                      <div style={{ marginBottom: '1rem' }}>
                        <span className="form__form-group-label required">Fecha:</span>
                        <div className="form" style={{ display: 'flex' }}>
                          <div
                            className="form__form-group-input-wrap form__form-group-input-wrap--error "
                            style={{ display: 'flex' }}
                          >
                            <Field
                              key={`${objetivo}.fecha`}
                              name={`${objetivo}.fecha`}
                              placeholder="Fecha"
                              component={TextBox}
                              autoComplete="false"
                              type="date"
                              onChange={(_, newValue) => onChangeText({
                                target: { name: `${objetivo}.fecha`, value: newValue }, name: fields.name, index,
                              })}
                              disabled={!materiaPeriodo.canEditarPlaneamiento}
                              readOnly={!materiaPeriodo.canEditarPlaneamiento}
                            />

                          </div>
                        </div>
                      </div>
                      <div style={{ marginBottom: '1rem' }}>
                        <span className="form__form-group-label required">Profesor:</span>
                        <div className="form" style={{ display: 'flex', flexWrap: 'nowrap' }}>
                          <Field
                            key={`${objetivo}.profesorMateria`}
                            name={`${objetivo}.profesorMateria`}
                            placeholder="Profesor"
                            onChange={props => onChangeSelect({
                              option: props,
                              name: fields.name,
                              target: { name: `${objetivo}.profesorMateria` },
                              index,
                            })}
                            options={profesores}
                            component={renderSelectField}
                            isDisabled={!materiaPeriodo.canEditarPlaneamiento}
                          />
                        </div>
                      </div>
                      <div style={{ marginBottom: '1rem' }}>
                        <span className="form__form-group-label required">Unidad:</span>
                        <div className="form" style={{ display: 'flex', flexWrap: 'nowrap' }}>
                          <div className="form__form-group-input-wrap form__form-group-input-wrap--error ">
                            <Field
                              key={`${objetivo}.unidad`}
                              name={`${objetivo}.unidad`}
                              placeholder="Unidad"
                              type="text"
                              maxLength="1024"
                              component={TextBox}
                              autoComplete="false"
                              onChange={({ target }) => onChangeText({ target, name: fields.name, index })}
                              disabled={!materiaPeriodo.canEditarPlaneamiento}
                              readOnly={!materiaPeriodo.canEditarPlaneamiento}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-9 col-sm-12">
                      <div className="form" style={{ display: 'flex' }}>
                        <span className="form__form-group-label required">Contenido:</span>
                        <div className="form__form-group-input-wrap form__form-group-input-wrap--error ">
                          <Field
                            key={`${objetivo}.contenidos`}
                            name={`${objetivo}.contenidos`}
                            placeholder="Contenidos"
                            type="textarea"
                            style={{ minHeight: '13rem' }}
                            maxLength="1024"
                            component={TextBox}
                            autoComplete="false"
                            onChange={({ target }) => onChangeText({ target, name: fields.name, index })}
                            disabled={!materiaPeriodo.canEditarPlaneamiento}
                            readOnly={!materiaPeriodo.canEditarPlaneamiento}
                          />
                        </div>
                      </div>
                    </div>
                  </Row>
                </div>
              </div>
            );
          })}
        </div>
        {
          submitFailed && error && (
            <span className="form__form-group-error" style={{ marginBottom: '0.5rem' }}>
              {error}
            </span>
          )
        }
      </div>
    </div>
  );
};

CronogramaClasesTable.propTypes = {
  onDeleteItemArray: PropTypes.func.isRequired,
  onChangeText: PropTypes.func.isRequired,
  onChangeSelect: PropTypes.func.isRequired,
  fields: PropTypes.shape({}).isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  profesores: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  meta: PropTypes.shape({}),
  materiaPeriodo: PropTypes.shape({}).isRequired,
};

CronogramaClasesTable.defaultProps = {
  meta: {},
};

export default CronogramaClasesTable;
